module.exports = __webpack_public_path__ + "static/img/fortnox_img.02c5a16.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/fortnox_img.png
// module id = ybtt
// module chunks = 1